import {Component, Host, h, Prop} from '@stencil/core';

@Component({
  tag: 'me-section',
  styleUrl: 'me-section.scss',
  shadow: false,
})
export class MeSection {

  @Prop({ reflect: true }) theme?: string;
  @Prop({ reflect: true }) fullWidth?: 'all' | 'mobile';

  render() {
    const classList = [
      'me-section',
      this.theme ? `me-section--${this.theme}` : null,
      this.fullWidth ? `me-section--full-width-${this.fullWidth}` : null,
    ].filter(c => !!c).join(' ');

    return (
      <Host class={classList}>
        <slot></slot>
      </Host>
    );
  }

}
